module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head1"
  }, [_vm._v("“IN MEMORY”")]), _vm._v(" "), _c('div', {
    staticClass: "image-break"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/11-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Jeffrey Heagerty circa 1983. "), _c('i', [_vm._v("Courtesy Robert Smallwood.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("By Lisa-Ann McGahee, July 1984")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("For Jeff")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("It broke our hearts to lose you, but you did not go alone.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A part of us went with you the day God took you home.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A million times we need you, a million times we cried.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If love could have saved you, you never would have died.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To the grave we traveled, the flowers placed with care.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("But no one knows the heartaches as we turn and leave you there.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("No farewells were spoke, no time to say goodbye.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You were gone before we knew, and only God knows why.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If tears could build a stairway, and heartaches make a lane,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("we would walk our way to heaven and bring you back again.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We smiled because we loved him. We cry because we lost him.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("Missed by Mom and Dad and Brothers and Lisa and Friends.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcde3f10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inmemory.vue
// module id = 75
// module chunks = 0